export default __webpack_public_path__ + "static/media/appstore_black.08c7d519.svg";